import React, { useState } from 'react';
import Popup from '../../common/Popup';
import PrematchContext from '../../contexts/PrematchContext';
import SelectionContext from '../../contexts/SelectionContext';
import { getLabel } from '../../data/labels';
import SelectionTournament from './SelectionTournament';
import { getConfiguration } from '../../data/utils';

function SelectionCountry(props) {
    const selectionContext = React.useContext(SelectionContext);
    const prematchContext = React.useContext(PrematchContext);
    const [popupSettings, setPopupSettings] = useState(null);
    const [checked, setChecked] = useState(false)

    function handleClick() {
        const tournamentsIds = props.tournaments.filter(t => t.filters[currentFilter] !== undefined).map(t => t.uniqueId);

        let selectedTournaments = selectionContext.tournaments;
        const unselectedTournaments = tournamentsIds.filter(function (tournament) {
            return (selectedTournaments.indexOf(tournament) === -1);
        });

        if (unselectedTournaments.length > 0 && unselectedTournaments.length <= tournamentsIds.length) {
            selectedTournaments.push(...tournamentsIds);
            selectionContext.setTournaments(selectedTournaments);
            setChecked(true)
        } else {
            selectedTournaments = selectionContext.tournaments.filter(t => tournamentsIds.indexOf(t) === -1);
            selectionContext.setTournaments(selectedTournaments);
            setChecked(false)
        }
    }

    function handleConfirm(e) {
        e.preventDefault();
        e.stopPropagation();
        if (selectionContext?.tournaments?.length > 0) {
            prematchContext.setTournaments(selectionContext.tournaments);
        } else {
            setPopupSettings({
                title: getLabel('prematch_page.print_bets.error_popup.title'),
                message: getLabel('prematch_page.print_bets.error_popup.no_tournaments'),
                dismissButtonText: getLabel('prematch_page.print_bets.error_popup.confirm_button')
            });
        }
    }
    const icoCategory = props.categoryIcon;
    const currentFilter = prematchContext.temporalFilter;
    const conf = getConfiguration();

    return (
        <>
            {popupSettings != null &&
                <Popup {...popupSettings} dismiss={() => setPopupSettings(null)} />
            }
            <div className="w-100 selezione-sport-box">
                <div className="box-paese">
                    <div className="nome-paese d-flex align-items-center margine-giu pointer" onClick={handleClick}>
                        <div className={`img-fluid bandierina-paese-selezione ico-cat ${icoCategory}`}></div>
                        <span>{props.descrizione}</span>
                        {props.isLive &&
                            <span className="live-badge ml-1"></span>
                        }
                        {conf.iwh && <input type="checkbox" className="checkbox__wh checkbox__wh-wrapper" defaultChecked={checked} />}
                        <i className="fas fa-play ml-auto" onClick={handleConfirm}></i>
                    </div>
                    <div className="lista-selezionabili">
                        <ul>
                            {props.tournaments.filter(t => t.filters[currentFilter] !== undefined).map(t => {
                                return (
                                    <SelectionTournament key={t.id} {...t} />
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SelectionCountry;